import { useParams } from 'react-router-dom';
import React, { useEffect, useState, useRef } from 'react';
import { useAuth } from './AuthContext'; // Pas het pad aan naar je AuthContext
import './MyTrainings.css'; // Importeer de bijbehorende CSS
import backicon from './Back Icon.png';
import icon_MyAccount from './My Account Icon.png';
import icon_Logout from './Logout Icon.png';
import icon_SwitchCompany from './Switch Company Icon.png';
import icon_MyProfile from './My Profile Icon.png';
import icon_Help from './Icon Help.png';
import icon_ConfigCompany from './Icon Config Company.png';
import icon_Copy from './Icon Copy.png';
import './App.css';
import { useNavigate } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import { useTable, usePagination, useSortBy, useGlobalFilter } from 'react-table';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { Resizable } from 're-resizable';
import ReactPaginate from 'react-paginate';


const popupMenuStyle = {
    position: 'absolute',
    backgroundColor: 'white',
    border: '1px solid grey',
    zIndex: 1000,
    padding: '10px',
    boxShadow: '5px 0px 10px rgba(0, 0, 0, 0.2)', // Rechtse schaduw
    transform: 'scale(1)', // Begin iets kleiner
    transition: 'transform 1s ease-in-out', // Overgangseffect
    borderRadius: '5px', // Afgeronde hoeken
  };
  
const iconStyle = {
    cursor: 'pointer', // Handcursor bij hover
    height: '4vh',
    margin: '5px 15px'
  };
  
const menuItemStyle = {
    display: 'flex',
    alignItems: 'center',
    margin: '5px 15px',
    whiteSpace: 'nowrap' // Voorkomt dat de tekst wordt afgebroken naar een nieuwe regel
  };


function MyTrainings() {
    const { user, updateUser } = useAuth();
    const [menu2Open, setMenu2Open] = useState(false);
    const menu2Ref = useRef(null);
    const { logout } = useAuth(); // Haal de logout-functie uit de context
    const navigate = useNavigate(); 
    const [companyName, setCompanyName] = useState(null);  
    const { companyId } = useParams();
    const [activeMenu, setActiveMenu] = useState('myTrainings');  // Standaard is 'My Trainings' actief
    const [showPopupMessage, setShowPopupMessage] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [reload, setReload] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('Support');
    const [Request_message, setRequestMessage] = useState("");
    const [showHelpPopup, setShowHelpPopup] = useState(false);
    const [trainingCalendarData, setTrainingCalendarData] = useState([]);
    const [trainingRegisteredData, setTrainingRegisteredData] = useState([]);
    const [allTrainings, setAllTrainings] = useState([]); // State voor het opslaan van alle trainingen
    const [showPopup_RegisterTraining, setShowPopup_RegisterTraining] = useState(false);
    const [showPopup_CancelTraining, setShowPopup_CancelTraining] = useState(false);

    const allowedUserIds = [53, 45, 49, 106]; // Toegestane user_ids voor zichtbaarheid menu-item 'All Trainings'
    const userLocalStorage = localStorage.getItem('user');
    const userId = userLocalStorage ? JSON.parse(userLocalStorage).id : null;
    const [selectedTrainingId, setSelectedTrainingId] = useState(null); // State om geselecteerde training op te slaan
    const [selectedRegisteredId, setSelectedRegisteredTrainingId] = useState(null); // State om geselecteerde training op te slaan


    const AllTrainings_Columns = [
        {
          Header: 'Name',
          accessor: 'user_name', // De sleutel van de kolom in de data
        },
        {
          Header: 'E-mail',
          accessor: 'user_email',
        },
        {
          Header: 'Date',
          accessor: 'date',
          Cell: ({ value }) => (!isNaN(new Date(value)) ? new Date(value).toLocaleDateString() : 'Invalid Date'), // Formatteer datum
        },
        {
          Header: 'Description',
          accessor: 'description',
        },
        {
          Header: 'Location',
          accessor: 'location',
        },
        {
          Header: 'Registered at',
          accessor: 'datetime_created',
          Cell: ({ value }) => (!isNaN(new Date(value)) ? new Date(value).toLocaleString() : 'Invalid Date'), // Formatteer datum en tijd
        },
        {
          Header: 'Price',
          accessor: 'price',
          Cell: ({ value }) => `€ ${value}`, // Voeg '€' toe aan de prijs
        },
        {
          Header: 'Status',
          accessor: 'status',
        },
        {
          Header: '',
          accessor: 'id',
          disableSortBy: true, // Schakel sorteren uit voor deze kolom
          Cell: ({ row }) => {
            // Haal de waarden van de rij op
            const training = row.original;
            const trainingDate = new Date(training.date);
            const today = new Date();
            const daysUntilTraining = !isNaN(trainingDate)
              ? Math.floor((trainingDate - today) / (1000 * 60 * 60 * 24))
              : null;
            const isCancelDisabled = daysUntilTraining !== null && daysUntilTraining <= 2;
            const shouldShowCancelButton = training.status !== 'Cancelled';
    
            return shouldShowCancelButton ? (
              <button
                className="details-button"
                style={{ cursor: isCancelDisabled ? 'not-allowed' : 'pointer', width: '150px' }}
                onClick={() => handleShowCancelTrainingPopup(training.id)}
              >
                {isCancelDisabled ? 'Not Cancelable' : 'Cancel'}
              </button>
            ) : null;
          },
        },
      ];


    function DataTable({ data, columns, searchField, height }) {
      const [currentPage, setCurrentPage] = useState(0); // Houdt de huidige pagina bij
      const [filterInput, setFilterInput] = useState("");
    
      // Handler voor filter input veranderingen
      const handleFilterChange = e => {
        const value = e.target.value || undefined;
        setFilterInput(value); // Update de filterInput state
        setGlobalFilter(value); // Update de tabel's data filtering
      };
      
      const handlePageClick = (data) => {
        let selected = data.selected;
        setCurrentPage(selected);
        // plus andere logica die je misschien hebt voor het veranderen van pagina
      };
    
      const resizableHeader = (column, label) => {
        let labelContent = label;
        if (React.isValidElement(label)) {
          labelContent = label.props.children;
        }
  
        // Aangenomen dat je resizable logica gescheiden is en niet direct interfereert met de span voor het icoontje
        return (
          <Resizable
            enable={{ top: false, right: true, bottom: false, left: false, topRight: false, bottomRight: false, bottomLeft: false, topLeft: false }}
            defaultSize={{ height: 30 }}
            style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}
            handleComponent={{ right: <span className="CP_columnResizer" /> }}
          >
            <div {...column.getSortByToggleProps()} style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <span>{labelContent}</span>
                <span>{column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}</span>
              </div>
            </div>
          </Resizable>
        );
      };
     
      
    
      const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        rows,
        canPreviousPage,
        canNextPage,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        state: { pageIndex, pageSize },
        state,
        setGlobalFilter,
        preGlobalFilteredRows, // aantal rijen vóór het filteren
      } = useTable(
        {
          columns: columns, // HeaderColumns,
          data,
          initialState: { pageIndex: 0, pageSize: 100 },
        },
        useGlobalFilter,
        useSortBy,
        usePagination
      );
    
    
      // Bepaal het aantal gefilterde records
      const totalFilteredRecords = rows.length; 
    
      const totalItems = pageCount * pageSize; // Totaal aantal items, dynamisch bepaald of uit props/data
    
      // Bereken de start en eind itemnummers
      const startItem = totalFilteredRecords === 0 ? 0 : pageIndex * pageSize + 1;
      const endItem = Math.min(startItem + pageSize - 1, totalFilteredRecords);    
    
      // Stel de tekst samen voor weergave
      const paginationText = `${startItem} - ${endItem} van ${totalFilteredRecords}`;
    
      const { globalFilter } = state;
    
      return (
        <>
        {searchField && (  // Als searchField true is, toon de zoekbalk
          <div className="CP_table-top-bar" style={{ textAlign: 'right' }}>
            <input
              type="text"
              value={filterInput}
              onChange={handleFilterChange}
              placeholder="Search..."
            />
          </div>
        )}
        <div className="CP_table-container" style={{ width: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <div className="CP_table-container" style={{ width: '100%', display: 'flex', flexDirection: 'column', overflow: 'auto'}}>
            <table {...getTableProps()} className="CP_table">
              <thead className="sticky-header">
                {headerGroups.map((headerGroup, headerGroupIndex) => (
                  <tr {...headerGroup.getHeaderGroupProps()} key={`header-group-${headerGroupIndex}`}>
                    {headerGroup.headers.map((column, columnIndex) => (
                      <th {...column.getHeaderProps()} key={`header-${columnIndex}`} className="CP_table-header" style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                        <div style={{ 
                                boxShadow: '0px 1px 0px 0px grey', 
                                padding: '10px', // Voeg hier je padding toe
                                margin: '0', // Stel margin in indien nodig
                        }}>
                          {resizableHeader(column, column.Header)} 
                        </div>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                  {page.map((row, index) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()} key={row.original.id} className="CP_table-row"> 
                      {row.cells.map(cell => (
                        <td {...cell.getCellProps()} className="CP_table-cell">{cell.render('Cell')}</td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div style={{ width: '100%', display: 'flex', flexDirection: 'column'}}></div>
          <div className="CP_footer-container" style={{ display: 'flex', justifyContent: 'space-between', width: '100%', height: '50px' }}>
            <span className="CP_footer-info" style={{ width: '150px', textAlign: 'left' }}>{paginationText}</span>
            <span className="CP_footer-info" style={{ width: '100%' }}></span>
            <div className="CP_footer-info" style={{ width: '150px', textAlign: 'right', display: 'flex' }}>
              <ReactPaginate
                previousLabel={<i className="fas fa-arrow-left" style={{ cursor: 'pointer' }}></i>}
                nextLabel={<i className="fas fa-arrow-right" style={{ cursor: 'pointer' }}></i>}
                breakLabel={'...'}
                pageCount={pageCount}
                onPageChange={({ selected }) => gotoPage(selected)}
                containerClassName={'CP_footer-pagination'}
                activeClassName={'active'}
                marginPagesDisplayed={0}
                pageRangeDisplayed={0}
              />
            </div>
          </div>
        </div>
        </>
      );
    }

    const handleSendHelpButton = async (event) => {
      event.preventDefault(); // Prevent the page from refreshing
  
      // Haal de user_id en company_id uit je state of waar ze ook zijn opgeslagen
      const user = localStorage.getItem('user');
      let user_id = null;
      let user_name = null;
      let user_email = null;
      if (user) {
          user_id = JSON.parse(user).id;
          user_email = JSON.parse(user).email;
          user_name = JSON.parse(user).name;
      }
      const company_id = localStorage.getItem('companyId');
      const company_name = localStorage.getItem('companyName');
  
      setShowHelpPopup(false);
      
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/requestforsupport/`, {
          method: 'POST',
          headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
          },
          body: JSON.stringify({ 
              user_id: user_id,
              user_email: user_email,
              user_name: user_name,
              company_id: company_id,
              company_name: company_name,
              Request_category: selectedCategory,
              Request_message: Request_message,
              currentURL: window.location.href
          })
      });
  
      if (response.status === 401) {
          // Logout de gebruiker en verwijder token en user uit de lokale opslag
          localStorage.removeItem('user');
          localStorage.removeItem('token');
  
          await logout();
          setError('Session expired');

          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000); // Hide the popup after 3 seconds 
  
          navigate('/login/'+localStorage.getItem('companyId')); // Redirect naar de loginpagina
          return;
      }
  
      if (response.ok) {
          const data = await response.json(); // Parseert de JSON-response
          console.log('Request for support sent succesfully');
  
          setMessage('Request for support sent successfully');
          setShowPopupMessage(true);
          setTimeout(() => setShowPopupMessage(false), 3000); // Hide the popup after 3 seconds 
      } else {
          const data = await response.json(); // Parseert de JSON-response
          console.log('Failed to send request for support');
  
          setError('Error sending request for support: '+data.error);
          setShowErrorPopup(true);
          setTimeout(() => setShowErrorPopup(false), 3000); // Hide the popup after 3 seconds 
      }
    };

    const handleMyProfile = () => {
      navigate('/my-profile');
    };

    const handleLogout = () => {
        logout(); // Roep de logout-functie aan
        localStorage.removeItem('user');
        localStorage.removeItem('token');

        logout();

        navigate('/login/'+localStorage.getItem('companyId')); // Redirect naar de loginpagina // Redirect naar de loginpagina
      };

      const handleSwitchCompany = () => {
        navigate('/my-companies');
      };

      
      const handleMenu_Help = () => {
        setShowHelpPopup(true);
      };


  // Functie om alle trainingen op te halen
  const fetchAllTrainings = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/getAllTrainings`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch all trainings');
      }

      const data = await response.json();
      setAllTrainings(data.training_registered_all || []); // Werk de state bij met de opgehaalde trainingen
    } catch (error) {
      console.error('Error fetching all trainings:', error);
    }
  };

  const handleRegister = async () => {
    if (!selectedTrainingId || !userId) {
      console.error('Training ID of User ID is missing');
      return;
    }

    setIsLoading(true);

    // Haal de user_id en company_id uit je state of waar ze ook zijn opgeslagen
    const user = localStorage.getItem('user');
    let user_id = null;
    let user_name = null;
    let user_email = null;
    if (user) {
        user_id = JSON.parse(user).id;
    }
    const company_id = localStorage.getItem('companyId');
    const company_name = localStorage.getItem('companyName');
    
    const token = localStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/registerTraining`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
            user_id: user_id,
            training_id: selectedTrainingId
        })
    });

    if (response.status === 401) {
        setIsLoading(false);

        // Logout de gebruiker en verwijder token en user uit de lokale opslag
        localStorage.removeItem('user');
        localStorage.removeItem('token');

        await logout();
        setError('Session expired');

        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000); // Hide the popup after 3 seconds 

        navigate('/login/'+localStorage.getItem('companyId')); // Redirect naar de loginpagina
        return;
    }

    if (response.ok) {
        setIsLoading(false);

        const data = await response.json(); // Parseert de JSON-response
        console.log('Training registered succesfully');

        setMessage('Training registered successfully');
        setShowPopupMessage(true);
        setTimeout(() => setShowPopupMessage(false), 3000); // Hide the popup after 3 seconds 

        setShowPopup_RegisterTraining(false);

        // Roep de reload functie aan om de datasets bij te werken
        setReload((prev) => !prev); // Toggle de reload state om useEffect opnieuw te triggeren

        setActiveMenu('myTrainings');
    } else {
        setIsLoading(false);

        const data = await response.json(); // Parseert de JSON-response
        console.log('Failed to register training');

        setError('Error registering training: '+data.error);
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000); // Hide the popup after 3 seconds 

        setShowPopup_RegisterTraining(false);
    }
  };

  const handleCancelTraining = async () => {
    if (!selectedRegisteredId || !userId) {
      console.error('Registered ID or User ID is missing');
      return;
    }
    // Haal de user_id en company_id uit je state of waar ze ook zijn opgeslagen
    const user = localStorage.getItem('user');
    let user_id = null;
    let user_name = null;
    let user_email = null;
    if (user) {
        user_id = JSON.parse(user).id;
    }
    const company_id = localStorage.getItem('companyId');
    const company_name = localStorage.getItem('companyName');
    
    const token = localStorage.getItem('token');
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/cancelTraining`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
            user_id: user_id,
            registered_id: selectedRegisteredId
        })
    });

    if (response.status === 401) {
        // Logout de gebruiker en verwijder token en user uit de lokale opslag
        localStorage.removeItem('user');
        localStorage.removeItem('token');

        await logout();
        setError('Session expired');
        
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000); // Hide the popup after 3 seconds 

        navigate('/login/'+localStorage.getItem('companyId')); // Redirect naar de loginpagina
        return;
    }

    if (response.ok) {
        const data = await response.json(); // Parseert de JSON-response
        console.log('Training cancelled succesfully');

        setMessage('Training cancelled successfully');
        setShowPopupMessage(true);
        setTimeout(() => setShowPopupMessage(false), 3000); // Hide the popup after 3 seconds 

        setShowPopup_CancelTraining(false);

        // Roep de reload functie aan om de datasets bij te werken
        setReload((prev) => !prev); // Toggle de reload state om useEffect opnieuw te triggeren

        setActiveMenu('myTrainings');
    } else {
        const data = await response.json(); // Parseert de JSON-response
        console.log('Failed to cancel training');

        setError('Error cancelling training: '+data.error);
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000); // Hide the popup after 3 seconds 

        setShowPopup_CancelTraining(false);
    }
  };


  // Functie om het All Trainings-menu te activeren en API-aanroep te doen
  const handleAllTrainingsClick = () => {
    setActiveMenu('allTrainings'); // Zet het actieve menu op 'allTrainings'
    fetchAllTrainings(); // Roep de functie aan om alle trainingen op te halen
  };
      
    useEffect(() => {
      const user = localStorage.getItem('user');
      let user_id = null;
      if (user) {
        user_id = JSON.parse(user).id;
      }
      const company_id = localStorage.getItem('companyId');
      const savedCompanyName = localStorage.getItem('companyName');
      setCompanyName(savedCompanyName);

      async function fetchData() {
        try {
          const token = localStorage.getItem('token');
          let response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/getTrainingData/` + user_id, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          });

          if (response.status === 401) {
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            
            setError('Session expired, please login again');
            setShowErrorPopup(true);
            setTimeout(() => setShowErrorPopup(false), 3000);

            navigate('/login/' + localStorage.getItem('companyId'));
            return;
          }

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          let data = await response.json();
          setTrainingCalendarData(data.training_calendar || []); // Zet de training_calendar data in de state
          setTrainingRegisteredData(data.training_registered || []); // Zet de training_registered data in de state

        } catch (error) {
          console.error('There was a problem fetching the training data:', error);
        }
      }

      fetchData();
    }, [reload, navigate]);

  // Functie om het register-poppup te tonen en de geselecteerde trainingId op te slaan
  const handleShowRegisterPopup = (trainingId) => {
    setSelectedTrainingId(trainingId); // Sla het geselecteerde training_id op
    setShowPopup_RegisterTraining(true); // Toon de pop-up
  };

  const handleShowCancelTrainingPopup = (registeredId) => {
    setSelectedRegisteredTrainingId(registeredId); // Sla het geselecteerde training_id op
    setShowPopup_CancelTraining(true); // Toon de pop-up
  };

  const handleCopySqlString = (sqlString) => {
    if (sqlString) {
      navigator.clipboard.writeText(sqlString).then(() => {
        setMessage('SQL string copied to clipboard!');
        setShowPopupMessage(true);
        setTimeout(() => setShowPopupMessage(false), 3000); // Hide the popup after 3 seconds 
      }).catch((err) => {
        console.error('Failed to copy text: ', err);

        setError('Failed to copy text: ', err);
        setShowErrorPopup(true);
        setTimeout(() => setShowErrorPopup(false), 3000);
      });
    }
  };

    useEffect(() => {
      if (activeMenu === 'reports') {
          // Voorbeeld API-aanroep met fetch:

      }
    }, [activeMenu]);

    useEffect(() => {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
          const parsedUser = JSON.parse(storedUser);
          updateUser(parsedUser);
      }
    }, [localStorage.getItem('user')]);
  
      // Als de gebruiker niet is ingelogd, render dan niets
    if (!user) 
    {
        //+navigate('/login/'+localStorage.getItem('companyId')); // Redirect naar de loginpagina // Redirect naar de loginpagina
        return null;
    }


  return (
    <CSSTransition
      in={true} // Deze waarde verandert wanneer je navigeert
      timeout={300}
      classNames="fade"
      unmountOnExit
    >
    <div className="page">

        <header style={{ borderBottom: '1px solid grey', position: 'relative' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <button className="back-button" onClick={() => navigate('/main')}><img src={backicon} alt="Logo" style={{ height: '5vh', margin: '15px' }} /></button>
            <div className="configCompanies-title">Trainings</div>

            <div style={{ position: 'relative' }}>
            <img src={icon_Help} className="selected-icon-variant-2" alt="Menu Help" style={iconStyle} title="Help & Support" onClick={handleMenu_Help} />
            <img src={icon_MyAccount} className="selected-icon-variant-2" alt="Menu 2" style={iconStyle} title="Account" onClick={() => setMenu2Open(!menu2Open)} />
            {menu2Open && (
                <div ref={menu2Ref} style={{ ...popupMenuStyle, right: '20px', top: '8vh' }}>
                <div style={{ color: 'grey', fontWeight: '500', textAlign: 'center', marginBottom: '2px' }}>{user?.name}</div>
                <div style={{ color: 'grey', textAlign: 'center', marginBottom: '5px' }}>{user?.email}</div>
                <div style={{ color: 'grey', textAlign: 'center', marginBottom: '5px', fontStyle: companyName ? 'normal' : 'italic' }}>
                    {companyName || 'No company assigned'}
                    {
                      user?.company_roleId && user?.company_roleId !== 3 && companyName && (
                        <a href={`/configcompany/${localStorage.getItem('companyId')}`}>
                          <img src={icon_ConfigCompany} alt="Configure company" title="Configure company" className="selected-icon" style={{ marginLeft: '10px', marginBottom: '3px', cursor: 'pointer', height: '17px', verticalAlign: 'middle' }} />
                        </a>
                      )
                    }
                </div>              
                <div style={{ borderBottom: '1px solid grey', marginBottom: '5px' }}></div>
                <div className='menu-item' onClick={handleMyProfile}><div style={menuItemStyle}><img src={icon_MyProfile} alt="My profile" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> My profile</div></div>
                <div className='menu-item' onClick={handleSwitchCompany}><div style={menuItemStyle}><img src={icon_SwitchCompany} alt="Switch company" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> Switch company</div></div>
                <div className='menu-item' onClick={handleLogout}><div style={menuItemStyle}><img src={icon_Logout} alt="Log out" style={{ height: '3vh', margin: '0px 10px 0px 0px' }} /> Log out</div></div>
                </div>
            )}
            </div>
        </div>
        </header>

        <div className="sidebar-cc">
          {/* Training Calendar menu-item */}
          <div className="menu-item-cc" onClick={() => setActiveMenu('trainingCalendar')}>
            <span className={activeMenu === 'trainingCalendar' ? 'active' : ''}>Training Calendar</span>
          </div>

          {/* My Trainings menu-item */}
          <div className="menu-item-cc" onClick={() => setActiveMenu('myTrainings')}>
            <span className={activeMenu === 'myTrainings' ? 'active' : ''}>My Trainings</span>
          </div>

          {/* All Trainings menu-item: alleen tonen als user_id gelijk is aan 45, 49 of 106 */}
          {allowedUserIds.includes(userId) && (
            <div className="menu-item-cc" onClick={handleAllTrainingsClick}>
              <span className={activeMenu === 'allTrainings' ? 'active' : ''}>All Trainings</span>
            </div>
          )}
        </div>

        <div className="content-cc">

          {activeMenu === 'trainingCalendar' && (
            <div className="report-table-container-cc" style={{ width: '1175px' }}>
              <h3>Training Calendar</h3>
              <div style={{height: '20px'}}></div>
              <table className="report-table-1" style={{ borderBottom: '1px solid lightgrey', borderRadius: '10px', width: '1150px' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'left', width: '100px' }}>Date</th>
                    <th style={{ textAlign: 'left', width: '250px' }}>Description</th>
                    <th style={{ textAlign: 'left', width: '150px' }}>Location</th>
                    <th style={{ textAlign: 'center', width: '150px' }}>Max Persons</th>
                    <th style={{ textAlign: 'center', width: '150px' }}>Available Seats</th>
                    <th style={{ textAlign: 'left', width: '75px' }}>Price</th>
                    <th style={{ textAlign: 'left', width: '150px' }}></th> {/* Lege kolomkop voor de knop */}
                  </tr>
                </thead>
                <tbody>
                  {trainingCalendarData
                    .filter((training) => training.visible === 1 && new Date(training.date) >= new Date()) // Filter op 'visible' en toekomstige datums
                    .map((training, index) => {
                      // Controleer of de training geregistreerd is door de user en de status niet 'Cancelled' is
                      const isRegistered = trainingRegisteredData.some(
                        (registeredTraining) =>
                          registeredTraining.training_calendar_id === training.id && registeredTraining.status !== 'Cancelled'
                      );

                      // Bereken het aantal beschikbare plaatsen
                      const availableSeats = training.maxpersons - training.stockamount;

                      // Controleer of de knop uitgeschakeld moet worden
                      const isFullyBooked = availableSeats <= 0; // Geen beschikbare plaatsen

                      // Stel de knoptekst in op basis van de status
                      const buttonText = isRegistered
                        ? 'Registered'
                        : isFullyBooked
                        ? 'Fully Booked'
                        : 'Register';

                      // Bepaal of de knop gedisabled moet zijn
                      const isButtonDisabled = isRegistered || isFullyBooked;

                      return (
                        <tr key={index}>
                          <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '100px' }}>
                            {new Date(training.date).toLocaleDateString()}
                          </td>
                          <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '250px' }}>{training.description}</td>
                          <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}>{training.location}</td>
                          <td style={{ verticalAlign: 'middle', textAlign: 'center', width: '150px' }}>{training.maxpersons}</td>
                          <td style={{ verticalAlign: 'middle', textAlign: 'center', width: '150px' }}>{availableSeats}</td>
                          <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '75px' }}>€ {training.price}</td>
                          {/* Extra kolom voor de knop */}
                          <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}>
                            <button
                              className="details-button"
                              style={{ cursor: isButtonDisabled ? 'not-allowed' : 'pointer', width: '150px' }} // Breedte van de knop ingesteld op 150px
                              onClick={() => !isButtonDisabled && handleShowRegisterPopup(training.id)} // Alleen registreren als de knop niet gedisabled is
                              //disabled={isButtonDisabled} // Schakel de knop uit als deze niet beschikbaar is
                            >
                              {buttonText} {/* Toon de juiste knoptekst */}
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            )}

          {activeMenu === 'myTrainings' && (
            <div className="report-table-container-cc" style={{ width: '1355px' }}>
                <h3>My Trainings</h3>
                  <div style={{height: '20px'}}></div>
                  <table className="report-table-1" style={{ borderBottom: '1px solid lightgrey', borderRadius: '10px', width: '1355px' }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'left', width: '100px' }}>Date</th>
                        <th style={{ textAlign: 'left', width: '250px' }}>Description</th>
                        <th style={{ textAlign: 'left', width: '150px' }}>Location</th>
                        <th style={{ textAlign: 'left', width: '200px' }}>Registered at</th>
                        <th style={{ textAlign: 'left', width: '75px' }}>Price</th>
                        <th style={{ textAlign: 'left', width: '100px' }}>Copy SQL</th>
                        <th style={{ textAlign: 'left', width: '150px' }}>Status</th>
                        <th style={{ textAlign: 'left', width: '175px' }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {trainingRegisteredData.length > 0 ? (
                        trainingRegisteredData.map((registered, index) => {
                          const trainingDate = new Date(registered.date); // Trainingsdatum
                          const registeredDate = new Date(registered.datetime_created); // Registratiedatum
                          const today = new Date();
                          const trainingDateString = !isNaN(trainingDate) ? trainingDate.toLocaleDateString() : 'Invalid Date';
                          const registeredDateString = !isNaN(registeredDate) ? registeredDate.toLocaleString() : 'Invalid Date';
                          const daysUntilTraining = !isNaN(trainingDate) ? Math.floor((trainingDate - today) / (1000 * 60 * 60 * 24)) : null;
                          const isCancelDisabled = daysUntilTraining !== null && daysUntilTraining <= 2;
                          const shouldShowCancelButton = registered.status !== 'Cancelled';

                          return (
                            <tr key={index}>
                              <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '100px' }}>{trainingDateString}</td>
                              <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '250px' }}>{registered.description}</td>
                              <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}>{registered.location}</td>
                              <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '200px' }}>{registeredDateString}</td>
                              <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '75px' }}>€ {registered.price}</td>
                              <td style={{ verticalAlign: 'middle', textAlign: 'center', width: '100px' }}>
                                {/* Kopieerknop */}
                                <button
                                  style={{ cursor: 'pointer', border: 'none', background: 'none' }}
                                  onClick={() => handleCopySqlString(registered.sql_string)}
                                  title="Copy SQL to clipboard"
                                >
                                  {/* Gebruik de geïmporteerde afbeelding in de src */}
                                  <img src={icon_Copy} alt="Copy" style={{ width: '20px', height: '20px' }} />
                                </button>
                              </td>
                              <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}>{registered.status || ''}</td>
                              <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '175px' }}>
                                {shouldShowCancelButton && (
                                  <button
                                    className="details-button"
                                    style={{ cursor: isCancelDisabled ? 'not-allowed' : 'pointer', width: '150px' }}
                                    onClick={() => handleShowCancelTrainingPopup(registered.id)}
                                  >
                                    {isCancelDisabled ? 'Not Cancelable' : 'Cancel'}
                                  </button>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="8" style={{ textAlign: 'center' }}>
                            No registered training data available. Check the training calendar to find out interesting courses.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
            </div>
            )}

          {activeMenu === 'allTrainings' && (
            <div className="DT-container" style={{ margin: '20px' }}>
                <h3>All Registered Trainings</h3>
                  <div style={{height: '20px'}}></div>
                  {/*
                  <table className="report-table-1" style={{ borderBottom: '1px solid lightgrey', borderRadius: '10px', width: '1530px' }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'left', width: '150px' }}>Name</th>
                        <th style={{ textAlign: 'left', width: '200px' }}>E-mail</th>
                        <th style={{ textAlign: 'left', width: '125px' }}>Date</th>
                        <th style={{ textAlign: 'left', width: '250px' }}>Description</th>
                        <th style={{ textAlign: 'left', width: '150px' }}>Location</th>
                        <th style={{ textAlign: 'left', width: '165px' }}>Registered at</th>
                        <th style={{ textAlign: 'left', width: '75px' }}>Price</th>
                        <th style={{ textAlign: 'left', width: '150px' }}>Status</th>
                        <th style={{ textAlign: 'left', width: '175px' }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {allTrainings.length > 0 ? (
                        allTrainings.map((training, index) => {
                          // Zet de waarden om naar Date-objecten
                          const trainingDate = new Date(training.date); // Trainingsdatum
                          const registeredDate = new Date(training.datetime_created); // Registratiedatum
                          const today = new Date();

                          // Controleren of de datum geldig is, anders 'Invalid Date' tonen
                          const trainingDateString = !isNaN(trainingDate) ? trainingDate.toLocaleDateString() : 'Invalid Date';
                          // Registered date in datum en tijd notatie
                          const registeredDateString = !isNaN(registeredDate) ? registeredDate.toLocaleString() : 'Invalid Date';

                          // Bereken het verschil in dagen tussen vandaag en de trainingsdatum
                          const daysUntilTraining = !isNaN(trainingDate) ? Math.floor((trainingDate - today) / (1000 * 60 * 60 * 24)) : null;

                          // Controleer of de Cancel-knop uitgeschakeld moet worden (als er nog 2 dagen of minder zijn tot de training)
                          const isCancelDisabled = daysUntilTraining !== null && daysUntilTraining <= 2;

                          // Bepaal of de Cancel-knop zichtbaar moet zijn op basis van de status
                          const shouldShowCancelButton = training.status !== 'Cancelled';

                          return (
                            <tr key={index}>
                              <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}>{training.user_name}</td>
                              <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '200px' }}>{training.user_email}</td>
                              <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '125px' }}>{trainingDateString}</td>
                              <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '250px' }}>{training.description}</td>
                              <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}>{training.location}</td>
                              <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '165px' }}>{registeredDateString}</td>
                              <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '75px' }}>€ {training.price}</td>
                              <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '150px' }}>{training.status || ''}</td>
                              <td style={{ verticalAlign: 'middle', textAlign: 'left', width: '175px' }}>
                                {shouldShowCancelButton && ( // Knop alleen tonen als de status niet 'Cancelled' is
                                  <button
                                    className="details-button"
                                    style={{ cursor: isCancelDisabled ? 'not-allowed' : 'pointer', width: '150px' }} // Breedte van de knop ingesteld op 150px
                                    onClick={() => handleShowCancelTrainingPopup(training.id)}
                                    //disabled={isCancelDisabled} // Knop disabelen als deze niet kan worden geannuleerd
                                  >
                                    {isCancelDisabled ? 'Not Cancelable' : 'Cancel'}
                                  </button>
                                )}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="9" style={{ textAlign: 'center' }}>No training data available.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  */}

                  {/* Vervang de bestaande tabel met de DataTable-component */}
                  <DataTable
                    data={allTrainings} // De data die in de tabel wordt weergegeven
                    columns={AllTrainings_Columns} // Kolommen definitie
                    searchField={true} // Toont een zoekveld bovenaan de tabel
                    height="73.5vh" // Stel de hoogte in voor de DataTable-container
                  />
            </div>
            )}

        </div>


        {showHelpPopup && (
          <div className="popup-container">
              <div className="popup-content">
              <h2 style={{ fontWeight: 'normal' }}>Request for support</h2>
              <div className="white-space"></div>
              <b>From:</b>
              <input
                  type="text"
                  placeholder="Username"
                  className="company-name-input"
                  disabled="true"
                  value={JSON.parse(localStorage.getItem('user'))?.name || ""}
              />
              <b>Company:</b>
              <input
                  type="text"
                  placeholder="Company name"
                  className="company-name-input"
                  disabled="true"
                  value={localStorage.getItem('companyName') || ""}
              />
              <div style={{ display: 'inline-block', marginRight: '10px' }}>
                  <div style={{ height: '20px', display: 'inline-block', fontSize: '16px', marginRight: '10px' }}><b>Request category:</b></div>
                  <select 
                    style={{ display: 'inline-block', width: '150px' }}
                    value={selectedCategory}
                    onChange={(e) => setSelectedCategory(e.target.value)}
                >
                    <option value="Support">Support</option>
                    <option value="Customization request">Customization request</option>
                </select>
              </div>
              <div className="white-space"></div>
              <div className="white-space"></div>
              <b>Message:</b>
              <div className="white-space"></div>
              <textarea
                  placeholder="Request for support message"
                  className="company-name-input"
                  rows="4"
                  value={Request_message}
                  style={{ display: 'inline-block', maxHeight: '200px', minHeight: '200px', maxWidth: '100%', minWidth: '100%' }}
                  onChange={(e) => setRequestMessage(e.target.value)}
              ></textarea>
              <div style={{ height: '50px' }}></div>
              <div className="buttons-container">
                  <button onClick={() => setShowHelpPopup(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                      Cancel
                  </button>
                  <button
                    onClick={handleSendHelpButton}
                    style={{ color: 'black', fontWeight: 'bold' }}
                  >
                  Send request
                  </button>
              </div>
              </div>
          </div>
        )}


        {showPopup_RegisterTraining && (
        <div className="popup-container">
            <div className="popup-content">
            <h2 style={{ fontWeight: 'normal' }}>Register Training</h2>
            <div className="white-space"></div>
            <div>
              Do you want to register this training and add it to My Trainings?
            </div>
            <div className="white-space"></div>
            <div className="white-space"></div>
            <div className="buttons-container">
              <button
                    style={{ color: 'black', fontWeight: 'bold' }}
                    onClick={handleRegister}
                >
                    Register
                </button>
                <button onClick={() => setShowPopup_RegisterTraining(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                    Cancel
                </button>
            </div>
          </div>
        </div>
        )}

        {showPopup_CancelTraining && (
        <div className="popup-container">
            <div className="popup-content">
            <h2 style={{ fontWeight: 'normal' }}>Cancel Training</h2>
            <div className="white-space"></div>
            <div>
              Are you sure you want to cancel this training?
            </div>
            <div className="white-space"></div>
            <div className="white-space"></div>
            <div className="buttons-container">
              <button
                    style={{ color: 'black', fontWeight: 'bold' }}
                    onClick={handleCancelTraining}
                >
                    Yes
                </button>
                <button onClick={() => setShowPopup_CancelTraining(false)} style={{ color: 'black', fontWeight: 'bold' }}>
                    No
                </button>
            </div>
          </div>
        </div>
        )}

        {showPopupMessage && <div className="popup-message">{message}</div>}
        {showErrorPopup && <div className="popup">{error}</div>}
        {isLoading && 
            <div className="loader-wrapper">
            <div className="loader"></div>
            </div>
        }
    </div>
    </CSSTransition>
  );
}

export default MyTrainings;